import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { SYNC_ATTENDANCE_FORM } from 'src/constants/FormNames';

import { saveToken } from 'src/reducers/desk/syncWithAttendance';

import SyncWithAttendance from './SyncWithAttendance';

const DEFAULT_INPUT = {
  api_attendance_id: '',
  api_attendance_token: '',
};

const SyncSettingForm = reduxForm({
  form: SYNC_ATTENDANCE_FORM,
})(SyncWithAttendance);

const mapStateToProps = () => ({
  initialValues: DEFAULT_INPUT,
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data, client) => {
    dispatch(saveToken(data, client));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SyncSettingForm);
